var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { InlineChildren, Spacing, Inset, Text, StackChildren, BorderWidth, Colors, } from '@doordash/design-language';
var HEADER_IMG_SIZE = '100px';
var HEADER_IMG_SIZE_MOBILE = '70px';
export var FullScreenContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  background-color: white;\n  margin: 0 ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  background-color: white;\n  margin: 0 ", ";\n"])), Spacing.XxLarge);
export var CategoryIconContainer = styled(StackChildren)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
export var CategoryImg = styled.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n"], ["\n  width: ",
    ";\n  height: ",
    ";\n"])), function (props) {
    return props.isMobile ? HEADER_IMG_SIZE_MOBILE : HEADER_IMG_SIZE;
}, function (props) {
    return props.isMobile ? HEADER_IMG_SIZE_MOBILE : HEADER_IMG_SIZE;
});
var HEADER_ICONS_CONTAINER_WIDTH = '100%';
var HEADER_ICONS_CONTAINER_WIDTH_MOBILE = '80%';
export var HeaderIconsContainer = styled(InlineChildren).attrs(function (props) { return ({
    alignItems: InlineChildren.Alignment.Center,
    justifyContent: InlineChildren.Justification.Center,
    size: props.isMobile
        ? InlineChildren.Sizes.Medium
        : InlineChildren.Sizes.XxLarge,
}); })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: ", ";\n  margin: auto;\n"], ["\n  width: ",
    ";\n  margin: auto;\n"])), function (props) {
    return props.isMobile
        ? HEADER_ICONS_CONTAINER_WIDTH_MOBILE
        : HEADER_ICONS_CONTAINER_WIDTH;
});
export var PageTitleText = styled(Text).attrs(function () { return ({
    styles: Text.Styles.PageTitle1,
    mobileStyles: Text.Styles.PageTitle2,
    textAlign: Text.TextAlignments.Center,
}); })(templateObject_5 || (templateObject_5 = __makeTemplateObject([""], [""])));
export var PageSubtitleText = styled(Text).attrs(function () { return ({
    styles: Text.Styles.Title1,
    mobileStyles: Text.Styles.Title2,
    weight: Text.Weights.Regular,
    textAlign: Text.TextAlignments.Center,
}); })(templateObject_6 || (templateObject_6 = __makeTemplateObject([""], [""])));
export var PageHeader = styled(Inset).attrs(function (props) { return ({
    size: props.isMobile ? Inset.Sizes.Medium : Inset.Sizes.Large,
    isStretched: true,
}); })(templateObject_7 || (templateObject_7 = __makeTemplateObject([""], [""])));
export var SectionTitleText = styled(Text).attrs(function () { return ({
    styles: Text.Styles.PageTitle2,
    mobileStyles: Text.Styles.Title1,
    textAlign: Text.TextAlignments.Center,
}); })(templateObject_8 || (templateObject_8 = __makeTemplateObject([""], [""])));
export var SectionSubtitleText = styled(Text).attrs(function () { return ({
    styles: Text.Styles.Title1,
    mobileStyles: Text.Styles.Title2,
    weight: Text.Weights.Regular,
    textAlign: Text.TextAlignments.Center,
}); })(templateObject_9 || (templateObject_9 = __makeTemplateObject([""], [""])));
export var SectionHeaderContainer = styled(Inset).attrs(function (props) { return ({
    size: props.isMobile ? Inset.Sizes.Small : Inset.Sizes.Medium,
    isStretched: props.isMobile ? false : true,
}); })(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  max-width: 700px;\n"], ["\n  max-width: 700px;\n"])));
export var IconAndText = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: center;\n  margin: ", " auto ", "px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: center;\n  margin: ", " auto ", "px;\n"])), Spacing.None, Spacing.XxxxSmall);
export var IconContainer = styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  height: ", "px;\n  padding-right: ", "px;\n"], ["\n  height: ", "px;\n  padding-right: ", "px;\n"])), Spacing.Large, Spacing.XxSmall);
export var SubSectionTitleText = styled(Text).attrs(function () { return ({
    styles: Text.Styles.Title1,
    mobileStyles: Text.Styles.Title2,
    textAlign: Text.TextAlignments.Center,
}); })(templateObject_13 || (templateObject_13 = __makeTemplateObject([""], [""])));
export var SubSectionHeaderContainer = styled(Inset).attrs(function (props) { return ({
    size: props.isMobile ? Inset.Sizes.XxSmall : Inset.Sizes.XSmall,
    isStretched: props.isMobile ? false : true,
}); })(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  max-width: 950px;\n  padding: ", ";\n"], ["\n  max-width: 950px;\n  padding: ",
    ";\n"])), function (props) {
    return props.isMobile ? Spacing.Small + "px 0 " + Spacing.XSmall + "px" : '0';
});
export var GiftCardBenefitsContainer = styled.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  max-width: 360px;\n"], ["\n  max-width: 360px;\n"])));
export var GiftCardListItem = styled.li(templateObject_16 || (templateObject_16 = __makeTemplateObject([""], [""])));
export var GiftCardListContainer = styled.ul(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  padding: 0 ", "px ", "px;\n  margin: 0;\n"], ["\n  padding: 0 ", "px ", "px;\n  margin: 0;\n"])), Spacing.Large, Spacing.Large);
export var SectionDivider = styled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  height: ", "px;\n  width: 100%;\n  max-width: 950px;\n  background: ", ";\n  margin: ", ";\n"], ["\n  height: ", "px;\n  width: 100%;\n  max-width: 950px;\n  background: ", ";\n  margin: ",
    ";\n"])), BorderWidth.Regular, Colors.BorderPrimary, function (props) {
    return props.isMobile
        ? Spacing.XxLarge + "px 0 " + Spacing.Large + "px"
        : Spacing.XxxxLarge + "px 0 " + Spacing.XLarge + "px";
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;
